import { createReducer, createSelector, on } from "@ngrx/store";
import { loadUserConfigurationSuccess } from "./user.actions";

export interface IUserConfiguration {
  name: string;
  division: { name: string, id: number };
  generalFreightEnabled?: boolean;
  specialisedFreightEnabled?: boolean;
  containersEnabled?: boolean;
}

export const initialUser: IUserConfiguration = {
  name: "",
  division: {
    name: "",
    id: 0,
  },
  generalFreightEnabled: false,
  specialisedFreightEnabled: false,
  containersEnabled: false,
};

export const userReducer = createReducer(
  initialUser,
  on(loadUserConfigurationSuccess, (state, { user }) => {
    if (state.name === "") {

      return {
        ...state,
        ...user

      };
    } else {
      return { ...state };
    }
  })
);

export const selectUserState = (state: any): IUserConfiguration => state.UserState;


export const selectUsername = createSelector(
  selectUserState,
  (state) => state.name
);

export const selectUserDivision = createSelector(
  selectUserState,
  (state) => state.division
);

export const selectFreightTypesEnabled = createSelector(
  selectUserState,
  (state) => {
    return ({
      generalFreightEnabled: state.generalFreightEnabled,
      specialisedFreightEnabled: state.specialisedFreightEnabled,
      containersEnabled: state.containersEnabled,
    })
  }
);


export const selectIsUserConfigurationLoaded = createSelector(
  selectUserState,
  (state) => state.name !== ""
);
